import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ensureFreshImages } from '@/lib/imageVersion'

// Prüft im Hintergrund, ob in Supabase Bilder ausgetauscht wurden.
// Falls ja, lädt sich die Seite automatisch einmal neu – so erscheint
// ein neues Bild ohne manuelles Zutun.
ensureFreshImages()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
